import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-26e99911")

_pushScopeId("data-v-26e99911")
const _hoisted_1 = { style: {"width":"20%"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("th", { style: {"width":"15%"} }, "Item Count", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("th", { style: {"width":"20%"} }, "Order Status", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("th", { style: {"width":"20%"} }, "Customer Status", -1)
const _hoisted_5 = {
  key: 0,
  style: {"width":"25%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_orders_table_row = _resolveComponent("orders-table-row")

  return (_openBlock(), _createBlock("table", null, [
    _createVNode("thead", null, [
      _createVNode("tr", null, [
        _createVNode("th", _hoisted_1, _toDisplayString(_ctx.title), 1),
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        (_ctx.configs.featureFlags().showOrderMessages)
          ? (_openBlock(), _createBlock("th", _hoisted_5, "Actions"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("tbody", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (order, key) => {
        return (_openBlock(), _createBlock(_component_orders_table_row, {
          key: key,
          order: order,
          onClick: $event => (_ctx.orderClicked(order))
        }, null, 8, ["order", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})